import React from 'react';
import styled from 'styled-components';

// Components
import { Typography } from '../../display/Typography';

type labelProps = React.LabelHTMLAttributes<HTMLLabelElement>;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xxxs}rem;
`;

export const Label = styled(Typography)<labelProps>``;

export const InputValue = styled.input`
  padding: 0 1rem;
  height: 4rem;
  width: calc(2.2rem + 4ch);
  border-radius: 0.5rem;
  font-size: ${({ theme }) => theme.fontSize.S};
  border: ${(props) =>
    !props.disabled ? `0.1rem solid ${props.theme.colors.black}` : 'none'};
  background-color: ${(props) =>
    !props.disabled ? props.theme.colors.white : props.theme.colors.greyLight};

  &:focus {
    outline: 0.08rem solid ${({ theme }) => theme.colors.black};
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.greySoftLight};
    opacity: 1;
  }

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.XS};
  }
`;
